import AppStoreImage from 'assets/img/AppStoreDownloadImage.png';
import Auth from 'components/Auth';
import SectionHeader from 'components/SectionHeader';
// import branch from 'branch-sdk';
import moment from 'moment-timezone';
import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";
import analytics from "util/analytics";
import { db, firebase, useAuth } from 'util/auth';
import Section from "./Section";
import ShareButton from 'components/ShareButton'
import ClassLocationSection from './ClassLocationSection';
import Accordion from 'react-bootstrap/Accordion'
import Alert from 'react-bootstrap/Alert'

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function ClassConfirmation(props) {

    // const location = useLocation()
    const auth = useAuth();
    const classID = props.match.params.platformID
    const selectedClass = useSelector(state => state.widget.classes.find(val => val.platformID == classID));

    function openAppStore() {
        analytics.track('Open App Clicked')
        window.open('https://sutrafitness.app.link')
    }

    const [reservation, setReservation] = useState(null);

    let reservation_id = useQuery().get('reservation_id');
    let session_id = useQuery().get('session_id');

    useEffect(() => {
        analytics.page({
            title: 'Class Confirmation'
        },{
            classID: classID
        })
        // console.log(classID)
    }, [classID])

    useEffect(() => {
        if (reservation) {
            analytics.track("Post Purchase Viewed", reservation);
        }
    }, [reservation])
    
    useEffect( () => {
        async function fetchReservation() {
            if (reservation_id) {
                try {
                    const doc = await db.collection("reservations").doc(reservation_id).get();
                    if (doc.exists) {
                        var res = doc.data();
                        res.platformID = doc.id;
                        setReservation(res);
                    }
                } catch (err) {
                    window.alert("Couldn't fetch reservation: " + err)
                    // console.log("Couldn't fetch reservation: " + err)
                }
            } else if (session_id) {
                try {
                    const doc = await db.collection("reservations").doc(session_id).get();
                    if (doc.exists) {
                        var res = doc.data();
                        res.platformID = doc.id;
                        setReservation(res);
                    }
                } catch (err) {
                    window.alert("Couldn't fetch reservation: " + err)
                }
            }
        }

        function loadReservations() {
            setTimeout(function() {
                fetchReservation()
            }, 2000)
            setTimeout(function() {
                if (!reservation) {
                    fetchReservation()
                }
            }, 5000)

        }
        loadReservations()
    }, [reservation_id, session_id]);

    useEffect( () => {
        if (reservation) {
            var obj = {}
            if (reservation.objectSnapshot) {
                obj = reservation.objectSnapshot
            } else {
                obj.instructor_name = reservation.instructor_name ?? "unknown";
                obj.instructor_id = reservation.instructor_id ?? "unknown"
            }
            obj.insert_id = reservation_id;
            console.log("success")
            console.log(obj)
            // analytics.track("bookingSuccess", obj)
        }

    }, [reservation]);

    function handleOpenSutraApp(e) {
        analytics.track("Open App Clicked")
        window.branch.link({
            tags: ['class'],
            channel: 'website',
            feature: 'widget',
            data: {
                shareType: "class",
                platformID: classID
            }
        }, function(err, link) {
            if (link && window.location) {
                window.location.assign(link);
                // window.open(link);
            }
        });
    }

    const [message, setMessage] = useState("")
    const [messageSent, setMessageSent] = useState(false);
    async function handleSendMessage(e) {
        e.preventDefault()
        if (message.length <= 3) {
            // window.alert("Please send a longer message")
            return
        }
        
        if (!auth.userData) {

            window.alert("You must be logged in")
            return
            
        }

        
        
        const new_message = {
            fromUserId: auth.userData.platformID,
            fromUserName: auth.userData.firstName,
            toUserId: selectedClass.instructor_id,
            toUserName: selectedClass.instructor_name,
            text: message,
            isViewed: false,
            createdAt: firebase.firestore.Timestamp.now()
        }

        const message_id = `${new_message.fromUserId}-${new_message.toUserId}-${new_message.createdAt}`

        try {
            await db.collection("messages").doc(message_id).set(new_message, {merge: true})
            setMessageSent(true);
            analytics.track('Send Private Message')
        } catch (err) {
            analytics.track('Send Private Message Failed')
            window.alert(err)
        }
        

        
    }
    function handleMessageChange(e) {
        setMessage(e.target.value)
    }

    moment.locale('en', {
        calendar : {
            lastDay : '[Yesterday]',
            sameDay : '[Today]',
            nextDay : '[Tomorrow]',
            lastWeek : '[last] dddd [at] LT',
            nextWeek : 'dddd [at] LT',
            sameElse : 'dddd MMM Do'
        }
    });

    var viewModel = {}
    if (selectedClass) {
        viewModel = {
            name: selectedClass.name ?? selectedClass.class_name,
            timeString: moment(selectedClass.start_time * 1000).format("ddd MMM Do • h:mma - ") + moment((selectedClass.start_time + (selectedClass.duration * 60)) * 1000).format("h:mma") + ` ${moment.tz(moment.tz.guess()).format('z')}`,
            instructorName: selectedClass.host_name,
            image: (selectedClass.images && selectedClass.images.length > 0) ? selectedClass.images[0] : "",
            shareLink: (process.env.REACT_APP_BOOKING_CANCEL_URL) + props.match.url.replace("confirm", "checkout"),
            location: selectedClass.location?.cityState ?? "LIVESTREAM",
            showMessageButton: ['5x0TQEZh7Hdk7lgcgYrzhU52zI93'].includes(selectedClass?.instructor_id ?? "")
            // location: selectedClass.location?.address ?? "LIVESTREAM",
        }
    }


    // const [accountCreated, setAccountCreated] = useState(false);
    /* found reservation (probably by reservation_id -- they probably booked it for free... send them a confirmation email!) */
    // const showSendConfirmationEmail =  reservation && reservation.existingUser === false && !reservation.customer_email;
    // const showSendConfirmationEmail = true;

    /* User doesn't have an account, and entered their email during checkout...
        Let's ask them to create an account! */
    // && reservation.customer_email;

    /* User entered email during stripe checkout and we detected they already have an account
        Let's prompt them to open up the app to see the reservation ! */
    const showOpenSutraApp = reservation && reservation.existingUser && reservation.customer_email;

    const subtitle = (reservation && reservation.customer_email) ? `We’ve sent a confirmation to ${reservation.customer_email}` : "";


    let height;
    const sendPostMessage = () => {
        let conatinerId = "fullWidthWidget"
        if (document.getElementById(conatinerId)) {
            if (height !== document.getElementById(conatinerId).offsetHeight) {
                height = document.getElementById(conatinerId).offsetHeight;
                window.parent.postMessage({
                  frameHeight: height
                }, '*');
                // console.log(height);
              }
        }
        
    }
    useEffect(() => {
        sendPostMessage()
    })
    return (
        
        <div
        className="mb-0 mt-4 mx-0"
        >
            <SectionHeader
            title="You're Booked!"
            // subtitle={subtitle}
            className="text-center"
             />

            {reservation && (
                <div className="text-center">
                    <h6>We've sent an email&nbsp;{reservation.customer_email ? `to ${reservation.customer_email}` : ""}</h6>
                    
                    <div className="mt-4 d-flex d-row align-items-center">

                        <ShareButton
                        className="m-auto"
                        buttonText="Invite friends to join!"
                        link={viewModel.shareLink}
                        />
                    </div>
                </div>
            )}
            <hr className="mt-5" />
            <Section
            className="mt-2 text-left"
            >
                <div className='d-flex flex-row justify-content-between align-items-center'>
                    <div>
                        <h4 className="mb-1 font-weight-bold">{viewModel.name}</h4>
                        <p style={{fontSize: 'smaller'}} className="my-0">{viewModel.timeString}</p>
                        <p className="my-0 instructorName">{viewModel.instructorName}</p>
                        <p className="my-1">{viewModel.location}</p>
                    </div>
                    <div className='m-0' style={{height: '100px', width: '100px', margin: '0 auto'}} >
                        <Image src={viewModel.image} rounded fluid />
                    </div>
                </div>
            </Section>

            {messageSent && (
                <Alert variant="secondary">
                    Message sent!
                </Alert>
            )}
            { messageSent === false && (
                <Accordion>
                    <Accordion.Collapse eventKey="0">
                        <Form className='my-4'>
                            <Form.Group controlId="exampleForm.ControlTextarea1">
                                <Form.Label>Leave a note or special request for {viewModel.instructorName}</Form.Label>
                                <Form.Control onChange={handleMessageChange} as="textarea" rows="3" />
                            </Form.Group>
                            {/* <Button onClick={handleSendMessage} className="primaryColor" variant="primary" type='submit'> 
                                Send Private Message
                            </Button> */}
                        </Form>
                    </Accordion.Collapse>
                    <Accordion.Toggle as={Button} onClick={handleSendMessage} eventKey="0" className='primaryColor'>
                        Send Private Message
                    </Accordion.Toggle>
                </Accordion>
            )}

            {reservation?.objectSnapshot && (
                <Section
                className="mt-4"
                >
                    <ClassLocationSection 
                    value={reservation.objectSnapshot}
                    classId={classID}
                    reserved={true}
                    isLoading={false}
                    />

                </Section>
            )}

            <Section
            bg={"light"}
            className="text-center mt-5"
            style={{marginRight: "-10px", marginLeft: "-10px"}}
            >
                <div className="pt-3 pb-5 mx-3 d-flex flex-column">
                    <a href="https://sutrafitness.app.link" className="power-item" id='logo'>SUTRA</a>
                    <p>Access your reservation and watch link, add special requests or injuries, add to calendar, cancel, and more!</p>
                    <div className="mt-3 align-self-center">
                        <a onClick={openAppStore} href="">
                            <div style={{
                                position: "relative",
                                width: '120px',
                                height: '40px'
                            }}>
                                <Image
                                    src={AppStoreImage}
                                    style={{
                                        position: 'absolute',
                                        top: '0',
                                        left: '0',
                                        width: '100%',
                                        height: '100%'
                                    }}
                                />
                            </div>
                        </a>
                    </div>
                </div>
            </Section>
        </div>
    );
}

export default ClassConfirmation;
